



























































import { Component, Vue, Prop } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import AgroTablePagination from "@/components/agroTablePagination/AgroTablePagination.vue";

export interface TableColumn {
  name: string;
  label: string;
}

@Component({
  name: "AgroTable",
  components: {
    AgroIcons,
    AgroTablePagination,
  },
  filters: {
    cropWords(value: string, maxLength: number) {
      if (!value) {
        return "";
      }

      if (value.length <= maxLength) {
        return value;
      }

      return `${value.toString().split("").slice(0, maxLength).join("")}...`;
    },
  },
})
export default class AgroTable extends Vue {
  private cropTypes = {
    SOY: "soybean",
    SUGAR_CANE: "sugarcane",
    CORN: "corn",
  };

  private showChild: boolean = false;
  private showPagination: boolean = true;

  private tableColumns: TableColumn[] = [
    { name: "more", label: "" },
    { name: "farmUuid", label: "ID" },
    { name: "yieldScore", label: "Score" },
    { name: "farmName", label: "Fazenda" },
    { name: "owner", label: "Proprietário" },
    { name: "city", label: "Cidade/Estado" },
    { name: "currentStepStatus", label: "Status" },
    { name: "farmArea", label: "Área" },
    { name: "summerCropType", label: "Cultura" },
    { name: "harvestYears", label: "Safra" },
    { name: "config", label: "" },
  ];
  private tableData: any = {
    content: [
      {
        farm_uuid: "1fe7642b-8c89-47d2-b5b3-ff0866cf9f2c",
        analysis_uuid: "3fa126ee-b3b0-4845-be72-2dd842bdcf48",
        owner_uuid: "f9fb7eac-f97b-4832-af6a-35b998853f2d",
        yield_score: "A",
        farm_name: "Alegrete",
        owner_name: "Rafael Coelho",
        city: "Rio Brilhante",
        state: "MS",
        farm_area: 24343.3,
        summer_crop_type: "SOY",
        winter_crop_type: "WINTER_CORN",
        created_at: "2020-06-26",
        harvest_years: [2020, 2019, 2018],
        status: "FINISHED",
        showChild: false,
      },
      {
        farm_uuid: "afdc13d7-67f9-4793-a44f-d018c96796da",
        analysis_uuid: "f3092d48-5866-4846-b5c4-88310c04664a",
        owner_uuid: "1887e4ec-2a88-4ba4-a1f6-7a3f8f5b82de",
        yield_score: "C",
        farm_name: "Alegrete",
        owner_name: "Rafael Coelho",
        city: "Rio Brilhante",
        state: "MS",
        farm_area: 24343.3,
        summer_crop_type: "SUGAR_CANE",
        winter_crop_type: null,
        created_at: "2020-06-26",
        harvest_years: [2020, 2019, 2018],
        status: "FINISHED",
        showChild: false,
      },
      {
        farm_uuid: "59d64653-5134-4584-9b8e-85564484a683",
        analysis_uuid: "150401ad-a9ae-4dab-8891-3fb05fa02ce6",
        owner_uuid: "88e5194b-fa0e-4c9b-9f45-de4571189a8d",
        yield_score: "A",
        farm_name: "Sol Nascente",
        owner_name: "José Roberto",
        city: "Sorriso",
        state: "MT",
        farm_area: 2343.3,
        summer_crop_type: "SOY",
        winter_crop_type: "WINTER_CORN",
        created_at: "2020-06-26",
        harvest_years: [2020, 2019, 2018],
        status: "PROCESSING",
        showChild: false,
      },
    ],
    pageable: {
      sort: {
        sorted: false,
        unsorted: true,
        empty: true,
      },
      offset: 0,
      pageNumber: 0,
      pageSize: 20,
      paged: true,
      unpaged: false,
    },
    totalPages: 3,
    totalElements: 3,
    last: true,
    size: 20,
    number: 0,
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    first: true,
    numberOfElements: 3,
    empty: false,
  };

  private handleClick(rows: any) {
    rows.showChild = !rows.showChild;
    this.$forceUpdate();
  }
}
